import { render, staticRenderFns } from "./HorizontalInfoCard.vue?vue&type=template&id=62e88980&scoped=true"
import script from "./HorizontalInfoCard.vue?vue&type=script&lang=js"
export * from "./HorizontalInfoCard.vue?vue&type=script&lang=js"
import style0 from "./HorizontalInfoCard.vue?vue&type=style&index=0&id=62e88980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e88980",
  null
  
)

export default component.exports